import React from 'react';
import PromotionBanner from './PromotionBanner';
import { getFeaturedPromotions } from '../../utils/promotions';
import './ServicesShowcase.css';

const ServicesShowcase = () => {
  // Promotions are data-driven via the central promotions engine (Slice S5).
  const featuredPromotions = getFeaturedPromotions();

  const services = [
    {
      id: 1,
      icon: 'fas fa-tools',
      title: 'Repair',
      subtitle: 'Expert Repairs',
      description:
        'Professional repair services for cracked screens, battery issues, water damage, and more. Same-day service available.',
      features: ['Screen Replacement', 'Battery Repair', 'Water Damage', 'Charging Issues'],
      accent: '#3a6df0',
      accent2: '#1e3fa8',
    },
    {
      id: 2,
      icon: 'fas fa-headphones',
      title: 'Accessories',
      subtitle: 'Top Quality',
      description:
        'Premium mobile accessories including cases, chargers, cables, screen protectors, and more for all devices.',
      features: ['Phone Cases', 'Chargers & Cables', 'Screen Protectors', 'Earbuds & Audio'],
      accent: '#12b1c6',
      accent2: '#0c7f90',
    },
    {
      id: 3,
      icon: 'fas fa-tags',
      title: 'Sell',
      subtitle: 'Best Prices',
      description:
        'Get top dollar for your devices. We offer competitive prices for smartphones and tablets in any condition.',
      features: ['Instant Quote', 'Same-Day Payment', 'All Brands Accepted', 'Any Condition'],
      accent: '#22b062',
      accent2: '#158043',
    },
    {
      id: 4,
      icon: 'fas fa-shopping-cart',
      title: 'Buy',
      subtitle: 'Quality Devices',
      description:
        'Shop certified pre-owned and new smartphones and tablets at unbeatable prices with warranty included.',
      features: ['New & Certified Pre-Owned', 'Warranty Included', 'Quality Tested', 'Best Prices'],
      accent: '#ffaa19',
      accent2: '#e07d00',
    },
    {
      id: 5,
      icon: 'fas fa-exchange-alt',
      title: 'Trade',
      subtitle: 'Upgrade Easy',
      description:
        'Trade in your old device and upgrade to something better. Hassle-free process with instant credit.',
      features: ['Instant Trade Value', 'Upgrade Options', 'Easy Process', 'Extra Credit Deals'],
      accent: '#7c4ddb',
      accent2: '#5a32a3',
    },
  ];

  return (
    <section className="ss-section services-showcase">
      <div className="container">
        {/* Header */}
        <div className="ss-head">
          <span className="ss-eyebrow">
            <i className="fas fa-mobile-alt" />
            What We Do
          </span>
          <h2 className="ss-title">
            Your One-Stop Shop for <span className="ss-grad">Smartphones &amp; Tablets</span>
          </h2>
          <p className="ss-sub">
            Whether you need expert repairs, want to sell your device, buy quality phones, or
            trade up to something better — we've got you covered with professional service and the
            best prices in town.
          </p>
        </div>

        {/* Cards */}
        <div className="ss-grid">
          {services.map((s) => (
            <article
              key={s.id}
              className="ss-card"
              style={{ '--accent': s.accent, '--accent-2': s.accent2 }}
            >
              <span className="ss-icon">
                <i className={s.icon} />
              </span>
              <h3 className="ss-card__title">{s.title}</h3>
              <span className="ss-card__eyebrow">{s.subtitle}</span>
              <p className="ss-card__desc">{s.description}</p>
              <ul className="ss-feats">
                {s.features.map((f, i) => (
                  <li key={i}>
                    <i className="fas fa-check" />
                    {f}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        {/* Device chips */}
        <div className="ss-trust">
          <span className="ss-chip">
            <i className="fab fa-apple" style={{ color: '#12203f' }} /> iPhone
          </span>
          <span className="ss-chip">
            <i className="fab fa-android" style={{ color: '#3ddc84' }} /> Samsung
          </span>
          <span className="ss-chip">
            <i className="fas fa-tablet-alt" style={{ color: '#ffaa19' }} /> iPad
          </span>
          <span className="ss-chip">
            <i className="fas fa-mobile-alt" style={{ color: '#7c4ddb' }} /> All Brands
          </span>
        </div>

        {/* Condition badges */}
        <div className="ss-conditions">
          <span className="ss-cond">
            <i className="fas fa-star" style={{ color: '#ffaa19' }} /> New Devices
          </span>
          <span className="ss-cond">
            <i className="fas fa-check-circle" style={{ color: '#28a745' }} /> Certified Pre-Owned
          </span>
          <span className="ss-cond">
            <i className="fas fa-heart" style={{ color: '#ff6b7a' }} /> Broken? No Problem!
          </span>
        </div>

        {/* Promotions — central promotions engine (S5). */}
        {featuredPromotions.map((promo) => (
          <PromotionBanner key={promo.id} promo={promo} />
        ))}
      </div>
    </section>
  );
};

export default ServicesShowcase;
